import { useEffect, useState } from "react";
import { executeQuery, REACT_APP_ADMIN_LINK, useDMQuery } from "../../utils";
import { integrationInfo } from "./IntegrationLanding";
import Integration11 from "./Integration11";
import Integration13 from "./Integration13";
import { useQuery } from "@tanstack/react-query";

const IntegrationDetails = () => {
  const [pageState, setPageState] = useState<"1.1" | "1.3">("1.1");
  const urlParams = new URLSearchParams(window.location.search);
  const type = urlParams.get("type");
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const integration = integrationInfo.find(
    (integration) => integration.type === type
  );

  const { data: credentialData, refetch: refetchCredentialData } = useDMQuery<{
    lti_credentials: {
      key: string;
      secret: string;
    };
    lti_1_3_credentials?: {
      issuer: string;
      client_id: string;
      deployment_id: string;
    };
  }>({
    path: "/admin_new/data/ltiCredentials",
    queryOptions: {
      enabled: false,
      staleTime: 1000 * 60 * 15,
      refetchOnWindowFocus: false,
    },
  });

  const { data: featureFlagsData } = useQuery<{ flags: string[] }>({
    queryKey: [`featureFlags-${user.teachercode}`],
    queryFn: () =>
      executeQuery({
        path: "/feature-flags/user",
        params: { userId: user.teachercode ?? "" },
      }),
    refetchOnWindowFocus: false,
  });

  const activeFeatureFlag =
    featureFlagsData?.flags?.includes("admin_integrations");

  useEffect(() => {
    refetchCredentialData();
  }, [refetchCredentialData]);

  if (!integration) {
    return <div>Integration not found</div>;
  }

  const buttonSelectedClass = "border-b-4 border-blue-500";
  const buttonUnselectedClass =
    "border-b-4 border-transparent text-dm-gray-500";

  return (
    <>
      <div className="bg-white px-6 py-8">
        <div className="mb-4">
          <a
            href={`${REACT_APP_ADMIN_LINK}/integrations`}
            className="text-blue-500"
          >
            <i className="far fa-arrow-left mr-2"></i> Back
          </a>
        </div>
        <div className="mb-2 flex items-center gap-4">
          <img
            src={integration.logoUrl}
            alt={`${integration.title} logo`}
            className="h-6"
          />
          <h5 className="font-serif text-2xl font-bold leading-[48px]">
            {integration.title}
          </h5>
        </div>
        <div className="mb-6">
          <p className="max-w-[600px] text-dm-gray-500">
            {activeFeatureFlag ? (
              <>
                We support a {integration.title} integration utilizing LTI 1.1
                or LTI 1.3. Please select the correct method for installation
                information.
              </>
            ) : (
              <>
                We support a {integration.title} integration utilizing LTI 1.1.
                Please select the guide below for more information.
              </>
            )}
          </p>
        </div>
        <div className="flex gap-16">
          <button
            className={`flex flex-col items-center gap-2 p-2 ${
              pageState === "1.1" ? buttonSelectedClass : buttonUnselectedClass
            }`}
            onClick={() => setPageState("1.1")}
          >
            {integration.title} 1.1
          </button>
          {(activeFeatureFlag || integration.type === "canvas") && (
            <button
              className={`flex flex-col items-center gap-2 p-2 ${
                pageState === "1.3"
                  ? buttonSelectedClass
                  : buttonUnselectedClass
              }`}
              onClick={() => setPageState("1.3")}
            >
              {integration.title} 1.3
            </button>
          )}
        </div>
      </div>
      {pageState === "1.1" && (
        <Integration11
          integration={integration}
          lti_credentials={credentialData?.lti_credentials}
        />
      )}
      {pageState === "1.3" && (
        <Integration13
          integration={integration}
          lti_1_3_credentials={credentialData?.lti_1_3_credentials}
        />
      )}
    </>
  );
};

export default IntegrationDetails;
